import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const AUTH_URL = process.env.REACT_APP_AUTH_URL;

export const apiPublic = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

export const apiAuth = axios.create({
  baseURL: API_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const apiAuthPublic = axios.create({
  baseURL: AUTH_URL,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});